import axios from 'axios';
import Config from "../core/config";
import {widgetLoader} from "./helpers/widgetHelpers";

console.log("widget version", '1.1.41');

let widgetListUrl = Config.api.getWidgetUrl(Config.language) +  window.document.location.pathname + window.document.location.search;

axios.get(widgetListUrl, Config.getApiConfig()).then(response => {
    widgetLoader(response.data);
});




// WEBPACK FOOTER //
// ./src/widgets/index.js